const { VUE_APP_AUTH_URL } = process.env;

import Vue from 'vue';

import axios from 'axios';
import VueAxios from 'vue-axios';

axios.defaults.baseURL = VUE_APP_AUTH_URL;
Vue.use(VueAxios, axios);

export default {
  root: VUE_APP_AUTH_URL
};